import { IDateRange } from '../models/SearchQuery';

const isValidDate = (value: Date): boolean => Number.isFinite(value.getTime());

const epochSeconds = (value: Date): number => Math.floor(value.getTime() / 1000);

export const createInclusiveLocalDateRange = (
  fromDate: Date,
  toDate: Date
): IDateRange | undefined => {
  if (!isValidDate(fromDate) || !isValidDate(toDate)) {
    return undefined;
  }

  const from = new Date(fromDate.getTime());
  from.setHours(0, 0, 0, 0);

  const to = new Date(toDate.getTime());
  to.setHours(23, 59, 59, 999);

  if (from.getTime() > to.getTime()) {
    return undefined;
  }

  return {
    from: epochSeconds(from),
    to: epochSeconds(to)
  };
};

export const normalizeInclusiveLocalDateRange = (
  range?: IDateRange
): IDateRange | undefined => {
  if (
    !range
    || !Number.isFinite(range.from)
    || !Number.isFinite(range.to)
  ) {
    return undefined;
  }

  return createInclusiveLocalDateRange(
    new Date(range.from * 1000),
    new Date(range.to * 1000)
  );
};
